import * as React from 'react'

type InputPrefixProps = {
  prefix: string
}

export const InputPrefix = ({ prefix }: InputPrefixProps) => {
  return (
    <div className="input-value">
      <span>{prefix}</span>
    </div>
  )
}
